(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-solicitante', {
            parent: 'app',
            url: '/chamados-por-solicitante',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados por solicitantes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-solicitante/chamados-por-solicitante.html',
                    controller: 'ChamadosPorSolicitanteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
